import { type JSX } from 'react';

export function Loader(props: {size: number}): JSX.Element{
    const s = props.size;
    return (
        <svg width={s} height={s} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="fa-icon" style={{animation: 'spin 1s linear infinite'}}>
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth={props.size * 0.125} strokeLinecap="round"
                strokeDasharray="31.4 62.8" />
            <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
        </svg>
    );
}
